import { AppLayout } from "../shared";
import Alerts from "../MasterOrg/Alerts";

const MasterOrgAlerts_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <Alerts props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrgAlerts_layout;
